export enum DialogTemplateIconColorEnum {
  PRIMARY = 'PRIMARY',
  ERROR = 'ERROR',
  TEXT = 'TEXT',
  TEXT_INVERTED = 'TEXT_INVERTED',
  INHERIT = 'INHERIT',
}
